import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { registerSW } from "@/lib/push";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Empfehlen from "@/pages/Empfehlen";
import Confirm from "@/pages/Confirm";
import Widerspruch from "@/pages/Widerspruch";
import Datenschutz from "@/pages/Datenschutz";
import Impressum from "@/pages/Impressum";
import TippgeberVereinbarung from "@/pages/TippgeberVereinbarung";
import BeraterRegister from "@/pages/BeraterRegister";
import KundeApp from "@/pages/KundeApp";
import BeraterDashboard from "@/pages/BeraterDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Loader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A1128]">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#C5A059] border-t-transparent" />
    </div>
  );
}

function Protected({ role, children }) {
  const { user } = useAuth();
  if (user === undefined) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.rolle !== role) {
    return <Navigate to={user.rolle === "berater" ? "/berater" : "/app"} replace />;
  }
  return children;
}

function App() {
  useEffect(() => {
    registerSW();
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/start/:refCode" element={<Landing />} />
            <Route path="/s/:refCode" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/empfehlen" element={<Empfehlen />} />
            <Route path="/berater-werden" element={<BeraterRegister />} />
            <Route path="/bestaetigen/:token" element={<Confirm />} />
            <Route path="/ablehnen/:token" element={<Widerspruch />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/tippgeber-vereinbarung" element={<TippgeberVereinbarung />} />
            <Route path="/app" element={<Protected role="kunde"><KundeApp /></Protected>} />
            <Route path="/berater" element={<Protected role="berater"><BeraterDashboard /></Protected>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors duration={3000} offset="calc(env(safe-area-inset-top) + 16px)" mobileOffset="calc(env(safe-area-inset-top) + 12px)" />
      </AuthProvider>
    </div>
  );
}

export default App;
